﻿import {arcGisObjectRefs} from "./arcGisJsInterop";
import * as binLabelCreator from "@arcgis/core/smartMapping/labels/bins.js";
import * as clusterLabelCreator from "@arcgis/core/smartMapping/labels/clusters.js";
import {buildJsRenderer} from "./jsBuilder";
import {buildDotNetLabelClass} from "./dotNetBuilder";
import MapView from "@arcgis/core/views/MapView";

export default class LabelCreatorWrapper {

    private dotNetRef: any;

    constructor(dotNetRef) {
        this.dotNetRef = dotNetRef;
    }
    
    async getBinLabelSchemes(params: any) {
        try {
            let results = await binLabelCreator.getLabelSchemes({
                layer: arcGisObjectRefs[params.layer.id] as any,
                renderer: buildJsRenderer(params.renderer) ?? undefined
            });
            return {
                primaryScheme: this.buildLabelSchemeResult(results.primaryScheme),
                secondarySchemes: results.secondarySchemes?.map(this.buildLabelSchemeResult)
            };
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
    
    async getClusterLabelSchemes(params: any) {
        try {
            let results = await clusterLabelCreator.getLabelSchemes({
                layer: arcGisObjectRefs[params.layer.id] as any,
                renderer: buildJsRenderer(params.renderer) ?? undefined,
                view: arcGisObjectRefs[params.viewId] as MapView
            });
            return {
                primaryScheme: this.buildLabelSchemeResult(results.primaryScheme),
                secondarySchemes: results.secondarySchemes?.map(this.buildLabelSchemeResult)
            };
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
    
    buildLabelSchemeResult(result: __esri.Scheme): any {
        return {
            name: result.name,
            fieldName: result.fieldName,
            labelingInfo: result.labelingInfo?.map(buildDotNetLabelClass)
        }
    }
}